import type { FunnelId } from './config';
import { BASELINE_CONFIG, PRICING_FUNNEL_CONFIGS } from './pricingFunnelConfigs';

export interface FunnelHomePageConfig {
  titleKey: string;
  censored: boolean;
  homePageVersion: string | null;
  loaderHomeVer: string | null;
  loaderTitles: Record<string, string> | null;
  useCustomInjectLoader: boolean;
}

export interface FunnelConfig {
  growthbookEnabled: boolean;
  quizVer: string | null;
  homeVer: string | null;
  landingVer?: string;
  homePageConfig?: FunnelHomePageConfig;
}

const CONFIGS: Record<FunnelId, FunnelConfig> = {
  'baseline': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: null,
    homePageConfig: {
      titleKey: 'bl_newss1_title',
      censored: false,
      homePageVersion: null,
      loaderHomeVer: null,
      loaderTitles: null,
      useCustomInjectLoader: false,
    },
  },
  'round-only': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: null,
    homePageConfig: {
      titleKey: 'bl_newss1_title',
      censored: false,
      homePageVersion: null,
      loaderHomeVer: null,
      loaderTitles: null,
      useCustomInjectLoader: false,
    },
  },
  'baseline-us': BASELINE_CONFIG,
  'google': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: null,
    homePageConfig: {
      titleKey: 'lp_v7_plan_selection_title1_copy',
      censored: true,
      homePageVersion: 'google_2',
      loaderHomeVer: 'google_2',
      loaderTitles: {
        'en': 'Get Your <span>Personal Kegel</span> Plan',
        'es': 'Obtén tu Kegel <span>Plan personal</span>',
        'es-mx': 'Obtén tu Kegel <span>Plan personal</span>',
        'pt': 'Obtém o teu Kegel <span>Plan pessoal</span>',
        'pt-br': 'Adquira <span>seu Kegel</span> Plan',
        'de': 'Hol dir deinen <span>persönlichen Kegel-Plan</span>',
        'fr': 'Ton Kegel <span>Plan personnalisé</span>',
        'it': 'Acquista il tuo Kegel <span>Plan personale</span>',
      },
      useCustomInjectLoader: false,
    },
  },
  'tiktok': {
    growthbookEnabled: true,
    quizVer: '2',
    homeVer: null,
    homePageConfig: {
      titleKey: 'lp_v7_plan_selection_title1_copy',
      censored: true,
      homePageVersion: 'tiktok_1',
      loaderHomeVer: 'tiktok_1',
      loaderTitles: {
        'en': 'Get Your <span>Personal Kegel</span> Plan',
        'es': 'Obtén tu Kegel <span>Plan personal</span>',
        'es-mx': 'Obtén tu Kegel <span>Plan personal</span>',
        'pt': 'Obtém o teu Kegel <span>Plan pessoal</span>',
        'pt-br': 'Adquira <span>seu Kegel</span> Plan',
        'de': 'Hol dir deinen <span>persönlichen Kegel-Plan</span>',
        'fr': 'Ton Kegel <span>Plan personnalisé</span>',
        'it': 'Acquista il tuo Kegel <span>Plan personale</span>',
      },
      useCustomInjectLoader: false,
    },
  },
  'baseline-v2': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: '06_happensAge',
    homePageConfig: {
      titleKey: 'bl_newss1_title',
      censored: false,
      homePageVersion: 'v2',
      loaderHomeVer: '2',
      loaderTitles: null,
      useCustomInjectLoader: true,
    },
  },
  'email': {
    growthbookEnabled: false,
    quizVer: '',
    homeVer: '',
    landingVer: 'landing_email',
  },
  'retargeting': {
    growthbookEnabled: false,
    quizVer: '',
    homeVer: '',
    landingVer: 'retargeting',
  },
  'baseline-promo': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: 'baseline_promo',
    homePageConfig: {
      titleKey: 'bl_newss1_title',
      censored: false,
      homePageVersion: 'v2',
      loaderHomeVer: '2',
      loaderTitles: null,
      useCustomInjectLoader: true,
    },
  },
  '01_feel18': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: '01_feel18',
    homePageConfig: {
      titleKey: 'bl_newss1_title',
      censored: false,
      homePageVersion: 'v2',
      loaderHomeVer: '2',
      loaderTitles: null,
      useCustomInjectLoader: true,
    },
  },
  '02_transform12w': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: '02_transform12w',
    homePageConfig: {
      titleKey: 'bl_newss1_title',
      censored: false,
      homePageVersion: 'v2',
      loaderHomeVer: '2',
      loaderTitles: null,
      useCustomInjectLoader: true,
    },
  },
  '03_transform28d': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: '03_transform28d',
    homePageConfig: {
      titleKey: 'bl_newss1_title',
      censored: false,
      homePageVersion: 'v2',
      loaderHomeVer: '2',
      loaderTitles: null,
      useCustomInjectLoader: true,
    },
  },
  '04_rewind28d': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: '04_rewind28d',
    homePageConfig: {
      titleKey: 'bl_newss1_title',
      censored: false,
      homePageVersion: 'v2',
      loaderHomeVer: '2',
      loaderTitles: null,
      useCustomInjectLoader: true,
    },
  },
  '05_rewind12w': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: '05_rewind12w',
    homePageConfig: {
      titleKey: 'bl_newss1_title',
      censored: false,
      homePageVersion: 'v2',
      loaderHomeVer: '2',
      loaderTitles: null,
      useCustomInjectLoader: true,
    },
  },
  '07_reflectage': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: '07_reflectage',
    homePageConfig: {
      titleKey: 'bl_newss1_title',
      censored: false,
      homePageVersion: 'v2',
      loaderHomeVer: '2',
      loaderTitles: null,
      useCustomInjectLoader: true,
    },
  },
  '08_control': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: '08_control',
    homePageConfig: {
      titleKey: 'bl_newss1_title',
      censored: false,
      homePageVersion: 'v2',
      loaderHomeVer: '2',
      loaderTitles: null,
      useCustomInjectLoader: true,
    },
  },
  '09_trainpelvic': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: '09_trainpelvic',
    homePageConfig: {
      titleKey: 'bl_newss1_title',
      censored: false,
      homePageVersion: 'v2',
      loaderHomeVer: '2',
      loaderTitles: null,
      useCustomInjectLoader: true,
    },
  },
  '10_top1decline': {
    growthbookEnabled: true,
    quizVer: null,
    homeVer: '10_top1decline',
    homePageConfig: {
      titleKey: 'bl_newss1_title',
      censored: false,
      homePageVersion: 'v2',
      loaderHomeVer: '2',
      loaderTitles: null,
      useCustomInjectLoader: true,
    },
  },
  ...PRICING_FUNNEL_CONFIGS,
};

export function resolveFunnelConfig(funnelId: FunnelId): FunnelConfig {
  return CONFIGS[funnelId] ?? CONFIGS.baseline;
}
